import React, { useEffect, useState } from "react";
import { db, firestore } from "./firebaseConfig";
import { doc, deleteDoc } from "firebase/firestore";
import { collection, getDocs } from "firebase/firestore";
import { toast } from "react-toastify";
import EditProducts from "../components/EditProducts";
import ImageViewer from "../components/ImageViewer";
import AdminNavbar from "../layouts/AdminNavbar";
import Footer from "../layouts/Footer";

const Products = () => {
  const access = sessionStorage.getItem("mandftoken");

  if (!access) {
    window.location.href = "/";
    sessionStorage.setItem("mandftoken", "");
    toast.info("You are not allowed to view this page.");
  }

  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState("");
  const [view, setView] = useState(false);
  const [show, setShow] = useState(false);
  const [state, setState] = useState({});
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, "products"));
      const productsList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProducts(productsList);
    } catch (error) {
      toast.error("Error fetching products");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleView = (imageUrls) => {
    setShow(true);
    setFiles(imageUrls || []);
  };

  const handleEdit = (product) => {
    setView(true);
    setState({
      id: product.id,
      title: product.title,
      description: product.description,
      category: product.category,
      status: product.status,
      sold: product.sold,
      imageUrls: product.imageUrls,
    });
  };

  const handleDelete = async (docId, productTitle) => {
    if (!window.confirm(`Are you sure you want to delete "${productTitle}"?`)) {
      return;
    }

    try {
      const docRef = doc(firestore, "products", docId);
      await deleteDoc(docRef);
      toast.success("Product deleted successfully");
      await fetchProducts();
    } catch (error) {
      console.error("Error deleting product:", error);
      toast.error("Error deleting product: " + error.message);
    }
  };

  const filteredProducts = products.filter((product) => {
    if (query === "") return true;
    const searchLower = query.toLowerCase();
    return (
      product.title?.toLowerCase().includes(searchLower) ||
      product.category?.toLowerCase().includes(searchLower) ||
      product.description?.toLowerCase().includes(searchLower)
    );
  });

  return (
    <>
      <AdminNavbar />
      <div className="container my-4">
        <div className="row mb-4">
          <div className="col-12">
            <h2 className="mb-3">Product Management</h2>
            <input
              className="form-control form-control-lg"
              type="text"
              placeholder="Search by title, category, or description..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover table-bordered align-middle">
              <thead className="table-dark">
                <tr>
                  <th style={{ width: "50px" }}>S/N</th>
                  <th>Title</th>
                  <th>Category</th>
                  <th style={{ width: "250px" }}>Description</th>
                  <th style={{ width: "80px" }}>Status</th>
                  <th style={{ width: "100px" }}>Availability</th>
                  <th style={{ width: "100px" }}>Images</th>
                  <th style={{ width: "180px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product, i) => (
                    <tr key={product.id}>
                      <td>{i + 1}</td>
                      <td>
                        <strong>{product.title}</strong>
                      </td>
                      <td>
                        <span className="badge bg-secondary">
                          {product.category}
                        </span>
                      </td>
                      <td>
                        <small>
                          {product.description?.substring(0, 100)}
                          {product.description?.length > 100 ? "..." : ""}
                        </small>
                      </td>
                      <td>
                        {product.status ? (
                          <span className="badge bg-success">Latest</span>
                        ) : (
                          <span className="badge bg-secondary">Regular</span>
                        )}
                      </td>
                      <td>
                        {product.sold ? (
                          <span className="badge bg-danger">Sold Out</span>
                        ) : (
                          <span className="badge bg-primary">Available</span>
                        )}
                      </td>
                      <td className="text-center">
                        <button
                          className="btn btn-sm btn-outline-info"
                          onClick={() => handleView(product.imageUrls)}
                          disabled={!product.imageUrls || product.imageUrls.length === 0}
                        >
                          <i className="fas fa-image me-1"></i>
                          View ({product.imageUrls?.length || 0})
                        </button>
                      </td>
                      <td>
                        <div className="btn-group" role="group">
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() => handleEdit(product)}
                            title="Edit Product"
                          >
                            <i className="fas fa-edit"></i> Edit
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(product.id, product.title)}
                            title="Delete Product"
                          >
                            <i className="fas fa-trash"></i> Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      <p className="mb-0 text-muted">
                        {query ? "No products match your search" : "No products found"}
                      </p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {!loading && filteredProducts.length > 0 && (
          <div className="mt-3">
            <p className="text-muted">
              Showing {filteredProducts.length} of {products.length} product(s)
            </p>
          </div>
        )}
      </div>

      <EditProducts
        view={view}
        setView={setView}
        state={state}
        fetchProducts={fetchProducts}
      />
      <ImageViewer show={show} setShow={setShow} file={files} />
      <Footer />
    </>
  );
};

export default Products;